<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="card-header">
      <mat-panel-title class="text-style">
        Nuevo {{'Material' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="formGroupNuevoMaterial">

      <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label><b>{{'TipoMaterial' | translate}}</b>: {{data?.TipoMaterialNombre}}</mat-label>
            </div>
          
          </mat-expansion-panel>
        </div>
        
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Nombre*</mat-label>
            <input matInput formControlName="Nombre" (keyup.enter)="onGuardarNuevoMaterial()" maxlength="150">
            <mat-error *ngIf="!formGroupNuevoMaterial.controls['Nombre'].valid">
              {{ getErrorNombre() }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex=50 fxFlex.xs=100 class="flex-item">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label *ngIf="!isUnidadMedidaSearching">Unidad de Medida*</mat-label>
            <mat-label *ngIf="isUnidadMedidaSearching">Cargando...</mat-label>
            <mat-select formControlName="UnidadMedidaMaterialId">
              <mat-option *ngFor="let s of unidadMedidaList" [value]="s.Id">{{s.Nombre}}</mat-option>
            </mat-select>
            <mat-error *ngIf="!formGroupNuevoMaterial.controls['UnidadMedidaMaterialId'].valid">
              {{ getErrorUnidadMedidaMaterialId() }}
            </mat-error>
          </mat-form-field>
        </div>

        <mat-card-actions style="margin-bottom: 20px;">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onGuardarNuevoMaterial()" color="primary"
              class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
            <button mat-raised-button (click)="onCancelNuevoMaterial()" color="warn"
              class="zb-button">Cancelar</button>
          </div>
        </mat-card-actions>

      </div>

    </form>

  </mat-expansion-panel>